import React from 'react';
import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';

export default function ImageCompare(props: { url1:string, url2:string }) {
  return (
    <div className="image-compare mb-2">
      <ReactCompareSlider
        itemOne={<ReactCompareSliderImage src={props.url1} alt="Image one" />}
        itemTwo={<ReactCompareSliderImage src={props.url2} alt="Image two" />}
      />
    </div>
  );
}